import MessageBag from 'services/message-bag';
export default class ValidationErrors extends MessageBag<string, string> {}
